import { UserProfile } from './courses';

export type BulkValidationResponse = {
  users: UserProfile[];
  errors: FieldError[];
  count: number;
};

export type FieldError = {
  data?: string; // Informacion adicional del error
  column: string; // Nombre de la columna
  row: number;
  errorCode: InscriptionErrorCodes;
};

export enum InscriptionErrorCodes {
  userNotFound = 'USER_NOT_FOUND',
  userInscripted = 'USER_INSCRIPTED',
}
